export class GrafanaConfiguration {
    constructor(
        public isEnabled: boolean,
        public url: string,
        public environmentName: string,
        public allowUrl: string
    ) {
        
    }

    static readonly defaultConfiguration: GrafanaConfiguration = {
        isEnabled: true,
        url: '',
        environmentName: '',
        allowUrl: ''
    };
}